import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * The "No Returns" badge, with no data dependencies. Pass `returnable` to say whether the thing
 * it sits on can be returned: `false` shows the badge, `true` hides it (still taking its space so
 * nothing shifts), and `undefined` (not known yet) is hidden too.
 */
@Component({
  selector: 'ideal-product-not-returnable-view',
  imports: [MatIconModule],
  standalone: true,
  templateUrl: './product-not-returnable-view.component.html',
  styleUrl: './product-not-returnable-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[hidden]': 'returnable() !== false',
    '[attr.line]': 'line() ? "" : null',
  },
})
export class ProductNotReturnableViewComponent {
  public readonly returnable = input<boolean | undefined>(undefined);
  /** Fill the available width and ellipsize, instead of hugging the text. */
  public readonly line = input(false, { transform: booleanAttribute });
}
